module.exports = __webpack_public_path__ + "img/UTHYRU-4.22d37772.jpg";